import moment from 'moment';
import _ from 'lodash';

import { ItemEnum, CreateEditUsageEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { KitchenItemPrepareInHouseFilterEnum } from 'Common/GridHelper';

import * as types from './types';

const INITIAL_STATE = {
  usageItems: [],
  fetchUsageItems: false,
  fetchUsageDetailError: null,
  selectedUsageDetail: null,
  fetchingUsageDetail: false,
  usageItemsLoadingError: null,
  submitted: false,
  submitError: null,
  submitting: false,
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SELECTED_USAGE_DETAIL:
      const selectedUsageDetail = action.payload;
      if (
        selectedUsageDetail &&
        selectedUsageDetail[CreateEditUsageEnum.UsageItems] &&
        Array.isArray(selectedUsageDetail[CreateEditUsageEnum.UsageItems])
      ) {
        selectedUsageDetail[
          CreateEditUsageEnum.UsageItems
        ] = selectedUsageDetail[CreateEditUsageEnum.UsageItems].map(item => ({
          ...item,
          [ItemEnum.SecQty]: item[ItemEnum.SecQty]
            ? Number(item[ItemEnum.SecQty]).toFixed(4)
            : '',
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PrepareInHouse]: item[ItemEnum.PrepareInHouse]
            ? KitchenItemPrepareInHouseFilterEnum.Yes
            : KitchenItemPrepareInHouseFilterEnum.No,
        }));
      }
      return {
        ...state,
        selectedUsageDetail: selectedUsageDetail,
      };
    case types.CREATE_EDIT_USAGE_ITEMS:
      return {
        ...state,
        usageItems: action.payload.map(item => ({
          ...item,
          [ItemEnum.BeginDate]: item[ItemEnum.BeginDate]
            ? moment(item[ItemEnum.BeginDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.EndDate]: item[ItemEnum.EndDate]
            ? moment(item[ItemEnum.EndDate]).format(DATE_FORMAT_FOR_UI)
            : '',
          [ItemEnum.PriQty]: null,
          [ItemEnum.SecQty]: null,
          [ItemEnum.PrepareInHouse]:
            typeof item[ItemEnum.PrepareInHouse] === 'string'
              ? item[ItemEnum.PrepareInHouse]
              : item[ItemEnum.PrepareInHouse]
                ? KitchenItemPrepareInHouseFilterEnum.Yes
                : KitchenItemPrepareInHouseFilterEnum.No,
        })),
      };
    case types.FETCHING_USAGE_DETAIL:
      return {
        ...state,
        fetchingUsageDetail: action.payload,
      };

    case types.FETCHING_USAGE_DETAIL_ERROR:
      return {
        ...state,
        fetchUsageDetailError: action.payload,
      };

    case types.USAGE_ITEMS_LOADING_ERROR:
      return {
        ...state,
        usageItemsLoadingError: action.payload,
      };

    case types.USAGE_LOADING:
      return {
        ...state,
        fetchUsageItems: action.payload,
      };

    case types.USAGE_DETAIL_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.SUBMITTING_USAGE_DETAIL:
      return {
        ...state,
        submitting: action.payload,
      };

    case types.SUBMIT_USAGE_DETAIL_ERROR:
      return {
        ...state,
        submitError: action.payload,
      };

    case types.RE_USAGE_ITEM_LIST:
      let clone = _.clone(state.usageItems, true);
      let remainedItem = [];
      if (action.payload && action.payload.length) {
        _.forEach(action.payload, item => {
          const index = _.findIndex(clone, function(cloneItem) {
            return item.ItemCode === cloneItem.ItemCode;
          });
          if (index !== -1) {
            remainedItem.push(clone[index]);
            clone.splice(index, 1);
          }
        });
      }
      clone = _.concat(remainedItem, clone);
      return {
        ...state,
        usageItems: clone,
      };

    case types.CLEAR_USAGE_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
        fetchUsageDetailError: null,
        usageItemsLoadingError: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/CreateEditUsage/reducer.js